<template>
  <div class="zoom">
    <p class="control">
      <button class="button is-light" v-on:click="zoomIn()" :disabled="transform === 1">
          <span class="icon">
            <i class="fas fa-search-plus"></i>
          </span>
      </button>
    </p>
    <p>
      <button class="button is-light" v-on:click="zoomOut()" :disabled="transform <= 0.5">
          <span class="icon">
            <i class="fas fa-search-minus"></i>
          </span>
      </button>
    </p>
  </div>
</template>

<script>
    export default {
        name: 'Zoom',
        props: ['elementId'],
        data() {
            return {
                transform: 1
            }
        },
        methods: {
            zoomIn() {
                if (this.transform < 1) {
                    // this.transform = this.transform + 0.05
                    this.transform = this.transform + 0.1
                    this.setZoom(this.transform)
                }
            },
            zoomOut() {
                if (this.transform > 0.5) {
                    // this.transform = this.transform - 0.05
                    this.transform = this.transform - 0.1
                    this.setZoom(this.transform)
                }
            },
            setZoom(zoom) {
                let scale = 'scale(' + zoom + ')'
                let canvas = document.getElementById(this._props.elementId)
                canvas.style.transform = scale
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Zoom.vue?a271e064